export enum Departments {
  Accountant = 'Accountant',
  SystemAdministrator = 'System Administrator',
  Recruitment = 'Recruitment',
  HR = 'HR',
  SalesAndMarketing = 'Sales And Marketing',
  Delivery = 'Delivery',
  Management = 'Management',
  BA = 'Business Analyst',
  SoftwareEngineer = 'Software Engineer',
  QAEngineer = 'QA Engineer',
  UIUXDesigner = 'UI/UX Designer',
  DevOpsEngineer = 'DevOps Engineer',
}
